// extracted by mini-css-extract-plugin
export default {"productGallery":"qH-z","inQuickShop":"rH-z"};